import React, {useEffect, useState} from "react";
import {useOktaAuth} from '@okta/okta-react';
import {checkedData, searchList} from '../shared/utils';
import {useAuthConfig} from "../shared/helper";
import {
    Box,
    Button,
    Container,
    FormControl,
    Grid,
    IconButton,
    Input,
    InputAdornment,
    Typography
} from '@deere/fuel-react';
import FeedbackStatusFilter from "../shared/filter/FeedbackStatusFilter";
import FeedbackPeriodFilter from "../shared/filter/FeedbackPeriodFilter";
import FeedbackList from "./FeedbackList";
import {Feedback} from "./Feedback";
import SearchIcon from "@material-ui/icons/Search";
import {Loading} from "../shared/Loading";
import {ErrorPage} from "../shared/ErrorPage";

export const Feedbacks = ({name}) => {
    let authAxios = useAuthConfig();
    const {authState} = useOktaAuth();
    const [feedbackList, setFeedbackList] = useState([]);
    const [statusExpanded, setStatusExpanded] = useState(true);
    const [periodExpanded, setPeriodExpanded] = useState(true);
    const [statusFilterData, setStatusFilterData] = useState([]);
    const [initStatusFilterData, setInitStatusFilterData] = useState([]);
    const [statusData, setStatusData] = useState([]);
    const [campPeriodData, setCampPeriodData] = useState([]);
    const [campPeriodFilterData, setCampPeriodFilterData] = useState([]);
    const [initPeriodFilterData, setInitPeriodFilterData] = useState([]);
    const [query, setQuery] = useState("");
    const [searchParam] = useState(["campaignTitle", "requestedByName", "requestedById", "dueDate"]);
    const [isLoading, setIsLoading] = useState(false)
    const [isBadRequestError, setIsBadRequestError] = useState(false);
    const [errorInfo, setErrorInfo] = useState("");

    const toggleStatusFilter = () => {
        setStatusExpanded(!statusExpanded);
    };

    const togglePeriodFilter = () => {
        setPeriodExpanded(!periodExpanded);
    };

    const resetFilter = () => {
        setStatusData(statusData)
        setStatusFilterData(initStatusFilterData)
        setCampPeriodFilterData(initPeriodFilterData)
    }

    const filterFeedbackList = (items) => {
        return items && items.filter((item) => {
            return statusFilterData.includes(item.props.feedback.responseStatus.description)
                && campPeriodFilterData.includes(item.props.feedback.campPeriod)
                && searchList(item.props.feedback, searchParam, query)
        })
    }

    const handleUpdatedStatus = data => {
        console.log(data)
        const arr = checkedData(data)
        setStatusFilterData(arr)
    }

    const handleUpdatedPeriod = data => {
        console.log(data)
        const arr = checkedData(data)
        console.log(arr)
        setCampPeriodFilterData(arr)
    }

    const getFeedbackComponent = (list) => {
        return list.map((item, index) => {
            return (
                <Feedback feedback={item} key={index}/>
            );
        });
    }

    const getCurrentCalendar = async () => {
        try {
            return await authAxios.get(`/calendar/current`);
        } catch (e) {
            console.error(e);
        }
    }

    const processFeedbackComponent = (response, status, calendar) => {
        const updatedData = response.map((row) => {
            const campPeriod = {campPeriod: `${row.fiscalYear}, ${row.period}`}
            row = {...campPeriod, ...row};
            return row;
        });
        const uniqueCampPeriod = [...new Map(updatedData.map(item =>
            [item["campPeriod"], item])).values()]

        const uniquePeriodIds = [...new Set(updatedData.map(item => item.campPeriod))];
        console.log(uniquePeriodIds);
        const currentPeriod = calendar?.nextRatingPeriod[0].period === 1 ? "Mid-Year" : "Year End";
        const currentPeriodId = calendar?.nextRatingPeriod[0].fiscalYear + ", " + currentPeriod;
        console.log(currentPeriodId);
        setCampPeriodData(uniqueCampPeriod)
        setCampPeriodFilterData([currentPeriodId]) // gets passed to filter
        setStatusData(status)
        setInitPeriodFilterData([currentPeriodId])
        setInitStatusFilterData("Incomplete")
        setStatusFilterData("Incomplete")

        const list = getFeedbackComponent(updatedData);
        setIsLoading(false)
        setFeedbackList(list);
    }

    useEffect(() => {
        setIsLoading(true)
        const getFeedbackStatus = async () => {
            try {
                return await authAxios.get(`/feedback/status`);
            } catch (e) {
                console.error(e);
            }
        };
        const getFeedbacks = async () => {
            try {
                return await authAxios.get(`/feedbacks`);
            } catch (e) {
                console.error(e);
                setErrorInfo("Sorry, you don't have access to this feature.")
                setIsBadRequestError(true)
                setIsLoading(false)
            }
        };
        getCurrentCalendar()
            .then((calendarRes) => {
                getFeedbackStatus()
                    .then(response => {
                        return getFeedbacks().then(res => {
                            if (res) {
                                processFeedbackComponent(res.data, response.data, calendarRes.data)
                            }
                        })
                    })
            });


        return () => {
            setFeedbackList(null);
            setIsLoading(false);
            setIsBadRequestError(false);
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authState]);

    return (
        <React.Fragment>
            {isLoading && (
                <Loading/>
            )}
            {!isLoading && !isBadRequestError && (
                <>
                    <Grid container>
                        <Grid item xs={12} md={3}>
                            <Typography variant="h1" component="h1" data-testid="PageName">
                                {name}
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={12} md={3}>
                            <Box mt={4}>
                                <Button variant="text-inline" size="large" onClick={resetFilter}>Clear All</Button>
                            </Box>
                            <Box mt={1}>
                                <div className="jdsn-facet-container">
                                    <FeedbackStatusFilter
                                        statusData={statusData}
                                        filteredData={statusFilterData}
                                        onExpandClick={toggleStatusFilter}
                                        onStatusUpdate={handleUpdatedStatus}
                                        expanded={statusExpanded}
                                        name={"Response Status"}/>
                                    <FeedbackPeriodFilter
                                        periodData={campPeriodData}
                                        filteredData={campPeriodFilterData}
                                        onExpandClick={togglePeriodFilter}
                                        onPeriodUpdate={handleUpdatedPeriod}
                                        expanded={periodExpanded}/>
                                    <Box className="fixed-bottom position-sticky view-result">
                                        <Button variant="primary" fullWidth={true} size="large">View Results</Button>
                                    </Box>
                                </div>
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={9}>
                            <Container>
                                <Box mt={4}>
                                    <FormControl fullWidth>
                                        <Input fullWidth placeholder="Filter these results" id="search"
                                               endAdornment={
                                                   <InputAdornment position="end">
                                                       <IconButton aria-label="search">
                                                           <SearchIcon style={{color: " #367c2b"}}/>
                                                       </IconButton>
                                                   </InputAdornment>
                                               }
                                               onChange={(e) => setQuery(e.target.value)}/>
                                    </FormControl>
                                </Box>
                                <Box mt={4}>
                                    <FeedbackList list={filterFeedbackList(feedbackList)}/>
                                </Box>
                            </Container>
                        </Grid>
                    </Grid>
                </>
            )}
            {!isLoading && isBadRequestError && (
                <ErrorPage
                    primaryMsg={errorInfo}
                    secondaryMsg={""}
                    backPage={"home"}
                    buttonText={"Home"}/>
            )}
        </React.Fragment>
    );
}
